const cmsContentMap = {
  carousels: {
    onboarding: "Wrqniy4AAC0A553e",
    changingCharacterStrength: "Wrqv6S4AACjB58LS",
    completedPlan: "WuB4YycAAGoyUMmo",
    notYetCompletedEngage: "Wy0H6D4AAJ0_PBxo",
  },
  info: {
    introOnDiscover: "WsOOQy4AAEAoDt5R",
    introOnEngage: "WsXwUC4AAIbWGUL8",
    introAssociateMembers: "WsX68y4AAO_cGXKw",
    loginNoAccount: "WvF6IycAAB7sm26D",
  },
  teamEffectiveness: {
    questionnaireQuestions: "X6Pv6RIAACMAN_o5",
    questionnaireUid: "team-effectiveness-questionnaire",
    reportUid: "team-effectiveness-report",
  },
  adhocReports: {
    groupReportUid: "ad-hoc-group-report",
  },
  homePage: {
    resourcesThemesPageUid: "home",
  },
  staticRoutes: {
    resourcesPageUid: "resources",
    teamSessionWheelUid: "team-session-wheel",
    afterPaymentSessionUid: "getting-your-team-started",
    foundationSession: "foundations-script",
    foundationsSessionUid: "foundations-pathway",
    foundationsCustomFrameworkSessionUid: "foundations-pathway-custom-framework",
    foundationsHackingGamesSessionUid: "foundations-pathway-hacking-games",
    foundationsTestSessionUid: "foundations-pathway-smart-resource1",
    foundationsRemappingSessionUid: "foundations-remapping",
    gyreInsightsSoloReportUid: "gyreinsights-your-solo-report",
    gyreInsightsTeamSoloUid: "gyreinsights-team-solo-report",
    goalCapturePageUid: "your-team-goals",
  },
  settings: {
    teamImageListId: "ZSa_IREAACQAiJjh",
    stringsId: "YL4IHBIAAJVrxkl3",
  },
  variableNames: {
    userFirstName: "variable-user-first-name",
    userCurrentStrengthItemName: "variable-user-current-strength-item-name",
    teamName: "variable-team-name",
  },
  smartCalloutNames: {
    soloSummary: "smart-callout-solo-summary",
  },
  themes: {
    nineQuestionsPathwayUid: "9-questions-team-pathways",
    teamInsightsPathwayUid: "team-insights-pathway",
  },
  develop: {
    beYourOwnBestCoachPlaylistUid: "be-your-own-best-coach-plan",
  },
  smartSearch: {
    promptsUid: "smart-search-prompts",
  },
};

export default cmsContentMap;
